<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';

defineProps({
  title: { type: String, default: 'Nenhum modelo de follow-up' },
  subtitle: {
    type: String,
    default:
      'Modelos de follow-up gerenciam o ritmo dos toques após o lead ser qualificado - ligação, e-mail, WhatsApp, visita. Crie em branco ou popule a partir de um pipeline com template.',
  },
});

const SAMPLES = [
  {
    name: 'Vendas Agressivo',
    description: '5 toques em 7 dias - ligação, e-mail, WhatsApp',
    steps: 5,
    anchor: 'Ao qualificar',
  },
  {
    name: 'Vendas Consultivo',
    description: '3 reuniões espaçadas em 30 dias',
    steps: 3,
    anchor: 'Ao qualificar',
  },
  {
    name: 'Pós-venda 90d',
    description: 'Boas-vindas, check-ins 7/30/90 e NPS',
    steps: 4,
    anchor: 'Ao qualificar',
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="flex flex-col gap-3 p-px">
        <div
          v-for="(tpl, i) in SAMPLES"
          :key="i"
          class="rounded-xl border border-n-weak bg-n-solid-1 px-4 py-3 flex items-center gap-4"
        >
          <span class="size-10 rounded-full bg-n-brand/10 flex items-center justify-center flex-shrink-0">
            <i class="i-lucide-list-checks size-5 text-n-brand" />
          </span>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2">
              <p class="text-heading-3 text-n-slate-12 mb-0">{{ tpl.name }}</p>
              <span class="inline-flex items-center px-1.5 py-0.5 rounded bg-n-alpha-2 text-label-small font-medium text-n-slate-11 uppercase tracking-wide">v1</span>
            </div>
            <p class="text-body-small text-n-slate-11 mt-0.5 mb-0 line-clamp-1">{{ tpl.description }}</p>
            <div class="flex items-center gap-3 mt-1 text-body-small text-n-slate-10">
              <span class="inline-flex items-center gap-1">
                <i class="i-lucide-list size-3" />
                {{ tpl.steps }} passos
              </span>
              <span class="inline-flex items-center gap-1">
                <i class="i-lucide-anchor size-3" />
                {{ tpl.anchor }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <slot name="actions" />
    </template>
  </EmptyStateLayout>
</template>
